import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';
import { GetCloudAssetsResponse } from '@cast/types-inventory';

const apiFn = apiClient.inventory.getAssetDiscoveryCommand;

const CLOUD_ASSET_ONBOARDING_COMMAND_QUERY_KEY =
  'cloud-asset-onboarding-command';

export const useCloudAssetOnboardingCommandQuery = <
  TSelected = GetCloudAssetsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<GetCloudAssetsResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: [CLOUD_ASSET_ONBOARDING_COMMAND_QUERY_KEY, params],
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
